import { Block } from "@/types/pages/blocks"
import PageBlock from "@/components/page/Block"
import { getBackgroundVars } from "@/utils/blockBackground"

export interface PageBlocksProps {
  blocks: Array<Block>
}

export default function PageBlocks({ blocks }: PageBlocksProps) {
  const blocksToDisplay = blocks.filter((block) => block.active).sort((a, b) => a.index - b.index)

  return blocksToDisplay.map((block) => (
    <div
      key={block.id}
      className="my-4 -mx-4 px-4"
      style={{ ...(block.css as React.CSSProperties), ...getBackgroundVars(block.css) }}
    >
      <PageBlock {...block} />
    </div>
  ))

}
